module.exports = __webpack_public_path__ + "static/dates-71ecec0fec2a0507d115d95a21ca3b5c.png";